module.exports = __webpack_public_path__ + "static/Composite_Primary_mobile-b69e24bd909236e49bdc9533527743e0.png";